import styled from 'styled-components';
//components
import { Row } from 'components/Layout/Grid';

export const Container = styled(Row)`
    display: flex;
    flex: 1;
    flex-direction: row;
    text-align: left;
    margin-top: 58px;
`